import * as React from 'react';
import {
  Body,
  Card as ThumbtackCard,
  ICardProps,
  IconButton40,
  IconNames16,
  Menu,
  Popover,
  Subheading1,
} from '@pinpointhq/thumbtack';

export interface ICard extends ICardProps {
  subheading?: string | JSX.Element;
  description?: string;
  menuItems?: React.ReactNode;
}

function CardHeader({ subheading, description, menuItems }: Pick<ICard, 'subheading' | 'description' | 'menuItems'>) {
  if (!subheading && !description && !menuItems) return null;

  return (
    <div className="mar-b-2">
      <div className="frow frow--items-start frow--justify-between frow--nowrap frow--items-center">
        <div className="col-flex-grow-1">
          {subheading && <Subheading1>{subheading}</Subheading1>}
          {description && (
            <Body muted={true} className="mar-t-1">
              {description}
            </Body>
          )}
        </div>
        <div>
          {menuItems ? (
            <Popover>
              <IconButton40 icon={IconNames16.OVERFLOW} />
              <Menu>{menuItems}</Menu>
            </Popover>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export function Card({ children, description, menuItems, subheading, ...cardProps }: ICard) {
  return (
    <ThumbtackCard {...cardProps}>
      <CardHeader {...{ description, menuItems, subheading }} />
      {children}
    </ThumbtackCard>
  );
}
